import React, { Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { useSelector } from "react-redux";

// Layouts
import * as layoutConstants from "../data/layout";
import VerticalLayout from "../layouts/Vertical";
import DetachedLayout from "../layouts/Detached";
import HorizontalLayout from "../layouts/Horizontal";
import FullLayout from "../layouts/Full";
import RouterChat from "./RouterChat";

// Components with lazy loading
const Spinner = React.lazy(() => import("../components/Spinners/Spinner"));
const Dashboard = React.lazy(() => import("../pages/dashboard/DashBoard"));
const Chat = React.lazy(() => import("../pages/chat/Chat"));
const ChatLs = React.lazy(() => import("../pages/chat/list/MainListChat"));
const ChatRoute = React.lazy(() => import("./RouterChat"));
const ListPersonal = React.lazy(() => import("../pages/ListPersonal"));
const SettingsPage = React.lazy(() => import("../pages/settings/SettingsPage"));
const GraphPage = React.lazy(() => import("../pages/GraphPage"));
const CoverPage = React.lazy(() => import("../pages/CoverPage"));
const UserProfile = React.lazy(() => import("../pages/personal/UserProfile"));
const AnswersPage = React.lazy(() => import("../pages/AnswersPage"));
const MarksPage = React.lazy(() => import("../pages/Markpage"));
const UpdateLogs = React.lazy(() => import("../pages/UpdateLogs"));

const loading = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ height: "85vh" }}
  >
    <Spinner />
  </div>
);

/**
 * Carga de componentes de forma dinámica
 *
 * @param {Object} props - Propiedades del componente
 * @returns {React.Component} Componente de carga
 */
const LoadComponent = ({ component: Component }) => (
  <Suspense fallback={loading()}>
    <Component />
  </Suspense>
);

/**
 * Rutas de la aplicación
 *
 * @returns {React.Component} Rutas de la aplicación
 */
const AllRoutes = () => {
  // Get the current layout type (string)
  const { layout } = useSelector((state) => ({
    layout: state.Layout,
  }));

  // Get the current layout
  const getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (layout.layoutType) {
      case layoutConstants.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case layoutConstants.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      case layoutConstants.LAYOUT_FULL:
        layoutCls = FullLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  let Layout = getLayout();

  // Retorna las rutas
  return useRoutes([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Navigate to="dashboard" />,
        },
        {
          path: "dashboard",
          element: <LoadComponent component={Dashboard} />,
        },
        {
          path: "agentes",
          element: <LoadComponent component={ListPersonal} />,
        },
        {
          path: "chat/*",
          // element: <LoadComponent component={Chat} />,
          element: <LoadComponent component={RouterChat} />,
        },
        {
          path: "respuestas",
          element: <LoadComponent component={AnswersPage} />,
        },
        {
          path: "estadisticas",
          element: <LoadComponent component={GraphPage} />,
        },
        {
          path: "etiquetas",
          element: <LoadComponent component={MarksPage} />,
        },
        {
          path: "cobertura",
          element: <LoadComponent component={CoverPage} />,
        },
        {
          path: "logs",
          element: <LoadComponent component={UpdateLogs} />,
        },
        {
          path: "ajustes",
          element: <LoadComponent component={SettingsPage} />,
        },
        {
          path: "perfil",
          element: <LoadComponent component={UserProfile} />,
        },
        {
          path: "*",
          element: <LoadComponent component={Dashboard} />,
        },
      ],
    },
  ]);
};

export { AllRoutes };
